module.exports = __webpack_public_path__ + "img/game-zww.8d56da74.png";